import { get, sumBy } from 'lodash'
import { formatCartItemModifiers } from '../utils/formatters'
import { OPEN_PRICE_REASON, PRICE_ADJUST_REASON } from '../VNItems/consts'

const displayPrice = (cartItem, modifiers) => {
  const priceInCents = get(cartItem, 'defaultPriceInCents', 0)
  const openPriceInCents = cartItem.openPriceInCents

  const basePrice = openPriceInCents ?? priceInCents
  const modifierPrice = sumBy(modifiers, (mod) => get(mod, 'defaultPriceInCents', 0))
  const price = basePrice + modifierPrice

  return `$${(price / 100).toFixed(2)}`
}

const CartItemViewModel = (cartItem) => {
  const modifiers = get(cartItem, 'modifiers', [])
  const notes = get(cartItem, 'notes', null)
  const modifiersString = formatCartItemModifiers(modifiers, notes)

  const priceInCents = cartItem.defaultPriceInCents || 0
  const openPriceInCents = cartItem.openPriceInCents
  const name = cartItem.name || ''
  const openName = cartItem.openName
  const reason = cartItem.openName?.length ? OPEN_PRICE_REASON : PRICE_ADJUST_REASON

  const item = {
    orderMaxAmount: get(cartItem, 'orderMaxAmount', null),
    orderMinCount: get(cartItem, 'orderMinCount', null),
    isAlcohol: get(cartItem, 'isAlcohol', false),
    id: get(cartItem, 'id', ''),
    name: openName || name,
    price: displayPrice(cartItem, modifiers),
    color: get(cartItem, 'color'),
    priceInCents: openPriceInCents ?? priceInCents,
    quantity: get(cartItem, 'quantity', 1),
    modifiers,
    notes,
    modifiersString,
    variant: cartItem.variants?.length ? cartItem.variants[0] : null,
  }

  //add open price props only when needed
  if (openPriceInCents !== null) {
    item.openPrice = true
    item.managerId = cartItem.managerId || ''
    item.reason = reason

    //add default price in cents only when present
    if (cartItem.defaultPriceInCents) {
      item.originalPriceInCents = cartItem.defaultPriceInCents
    }
  }

  return item
}

export default CartItemViewModel
